// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"90f44705","833":"65705f5d"}[chunkId] + ".css";
};